import React, { Component } from 'react'

const Main =({ ...props }) => {
    return (
      <main>
        {props.children}
      </main>
    )
}

export default Main;
